import { render, staticRenderFns } from "./NotificationsButton.vue?vue&type=template&id=4ad8b946&scoped=true"
import script from "./NotificationsButton.vue?vue&type=script&lang=ts"
export * from "./NotificationsButton.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsButton.vue?vue&type=style&index=0&id=4ad8b946&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad8b946",
  null
  
)

export default component.exports